/**
 * Main App Component - FBCA Architecture
 * Feature-Based Component Architecture with auto-discovery routing
 */

import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { AuthProvider } from './features/auth';
import { UserProvider } from './features/user';
import { SettingsProvider } from './shared/context/SettingsContext';
import { PageRouter } from './lib/page-router';
import { Header, Footer } from './shared/components';

// Layout wrapper component to conditionally show Header/Footer
function LayoutWrapper() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Pages that should NOT have Header/Footer (auth pages only)
  const noLayoutPaths = ['/auth', '/user/admin'];
  const shouldShowLayout = !noLayoutPaths.some(path => currentPath.startsWith(path));

  if (shouldShowLayout) {
    return (
      <>
        <Header />
        <PageRouter />
        <Footer />
      </>
    );
  }

  return <PageRouter />;
}

function App() {
  return (
    <Router basename="/">
      <AuthProvider>
        <UserProvider>
          <SettingsProvider>
            <LayoutWrapper />
          </SettingsProvider>
        </UserProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;